import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-modo-diligenciemiento',
  templateUrl: './modo-diligenciemiento.component.html',
  styleUrls: ['./modo-diligenciemiento.component.css']
})
export class ModoDiligenciemientoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModoDiligenciemientoComponent>,
  	@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  submit(res: string = '') {
    this.dialogRef.close(res);
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/shared/modals/modo-diligenciemiento/modo-diligenciemiento.component.ts